/**
 * Operator-facing names for the two UltraMsg sending accounts a city can be
 * pinned to (`city.whatsapp_instance`, values 1 and 2 — the api's
 * `ULTRAMSG_INSTANCE_*_ID` env vars).
 *
 * ONLY THE LABELS LIVE HERE. The phone numbers used to, and they drifted: this
 * file claimed instance 1 sent from 056-8599665 while UltraMsg had it linked to
 * a different account entirely. A number nobody can verify from the dashboard
 * is worse than no number, so the numbers now come from
 * `GET /api/messaging-health`, which asks UltraMsg directly — see
 * `hooks/useMessagingHealth.js`. Labels are UI copy and belong in the client.
 */
export const WHATSAPP_INSTANCE_LABELS = {
    1: "الرقم الأول",
    2: "الرقم الثاني",
};

/**
 * Display a raw UltraMsg number (`972552895625`) the way an operator reads it
 * (`055-2895625`). Falls back to the input when it is not a shape we know.
 *
 * @param {string|null|undefined} phone
 * @returns {string|null}
 */
export const formatWhatsappInstancePhone = (phone) => {
    if (!phone) return null;

    const digits = String(phone).replace(/\D/g, "");
    const local = digits.startsWith("972") ? `0${digits.slice(3)}` : digits;

    return local.length === 10 ? `${local.slice(0, 3)}-${local.slice(3)}` : local;
};
